import "pickadate/lib/picker.date.js"
import translations from "../translations"
import * as I18n from "../services/i18n"

export default class StantDatepicker
  constructor: (@input) ->

  options = ->
    input = @input

    # Obter traduções com fallback para evitar erros
    translations_content = $('#translations').data("content") || {}
    date_translations = translations_content.date || {}

    monthsFull: date_translations.month_names?.slice(1) || ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    monthsShort: date_translations.abbr_month_names?.slice(1) || ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    weekdaysFull: date_translations.day_names || ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
    weekdaysShort: date_translations.abbr_day_names || ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    today: I18n.t(translations(), 'datepicker.hoje'),
    clear: I18n.t(translations(), 'datepicker.limpar'),
    close: I18n.t(translations(), 'datepicker.fechar'),
    format: 'dd/mm/yyyy',
    formatSubmit: 'yyyy/mm/dd',
    editable: false,
    container: 'body'
    onOpen: ->
      div_wrapper = input.parent().find('div.special-field')
      div_wrapper.addClass 'filled'
    onClose: ->
      $(document.activeElement).blur()
      date_input = this.$node.siblings().find('.mask-date-field').attr('id')

      if date_input == undefined
        date_input = this.$node.siblings('.mask-date-field').attr('id')
      $('#' + date_input).val(this.$node.val()) unless this.$node.val() == ''

  pick: ->
    input = @input.pickadate(options.call(@))

  @init: ->
    new StantDatepicker($('.pickadate')).pick()